<template>

  <div class="custom-tile">

    <div class="custom-tile__head">

      <Text-Input
        key="label"
        field-label="label"
        field-name="label"
        class-name="custom-tile__input-label"
        :init-value=props.tile.label
        :init-touched="false"
        placeholder="Leave blank for no label"
        @update-value="updateProp"
        ></Text-Input>

    </div>

    <div class="custom-tile__body">

      <div class="custom-tile__title">

        <div class="custom-tile__title-label">Type</div>

        <select v-model="tileType" id="type" @change="updateProp('type', tileType)" style="border-color: #ccc; max-width: 140px;">
          <option value="image">Image</option>
          <option value="mod">Mod</option>
        </select>

        <div class="custom-tile__title-label">Size</div>

        <select v-model="tileSize" id="size" @change="updateProp('size', tileSize)" style="border-color: #ccc; max-width: 140px;">
          <option value="auto">Auto</option>
          <option value="large">Large</option>
          <option value="hero">Hero</option>
        </select>

        <div class="custom-tile__title-label">Title</div>

        <input type="text" v-model="tileTitle" @change="updateProp('title', tileTitle)" style="border-color: #ccc;" placeholder="Leave blank to use default title from mod (or empty if image)" />

      </div>

      <div v-if="tileType == 'image'">

        <Upload-Image
          :defaultPreviewUrl="imagePreviewUrl"
          @file-selected="handleFileSelected"
        />
      </div>

      <div v-if="tileType == 'mod'">

        <div @click="activateSelectMod" class="upload-image__button">
          <div class="upload-image__preview" v-if="!_.isNil(builder.currentItem.specs.tiles[props.index].mod)">
            <img :src="builder.currentItem.specs.tiles[props.index].mod.url" alt="Preview" />
          </div>
          <div style="margin-top: 10px; font-size: 80%;" v-if="!_.isNil(builder.currentItem.specs.tiles[props.index].mod)" v-html="builder.currentItem.specs.tiles[props.index].mod.title"></div>

          <div class="upload-image__btn">
            Select a mod
          </div>
        </div>

        <div v-if="selectModActive" class="custom-tile__lightbox-bg" @click="selectModActive = false"></div>
        <div v-if="selectModActive" :key="`tileModSelect_${builder.currentItem.specs.tiles[props.index].hash}`" class="custom-tile__lightbox">

          <select v-model="builder.tileModType" :key="`tileModType_${builder.currentItem.specs.tiles[props.index].hash}`" style="border-color: #ccc; max-width: 140px;">
            <option value="benchtopMaterial">Benchtops</option>
            <option value="panelFinish">Panel Finishes</option>
            <option value="doorProfile">Door Profiles</option>
            <option value="handles">Handles</option>
            <option value="corniceHeights">Cornice Heights</option>
            <option value="drawerTypes">Drawer Types</option>
            <option value="hardware">Hardware</option>
            <option value="frames">Frames</option>
            <option value="panels">Panels</option>
          </select>

          <Selector
            :key="`${builder.currentItem.specs.tiles[props.index].hash}_mod`"
            field-name="mod"
            :display-type=builder.panelFinish.displayType
            options-source="allModOptions"
            scope="specs"
            @select-option="selectMod"
          ></Selector>

        </div>
      </div>

    </div>

    <button class="button-circle l_grey custom-tile__remove-btn" @click.stop="remove()">
      <svg class="icon"><use xlink:href="#cross"></use></svg>
    </button>

  </div>

</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

var _ = require('lodash');
import axios from 'axios';

const props = defineProps([
  'index',
  'tile'
])

const emit = defineEmits(['tileRemove', 'tileUpdateProp'])

let selectedFile = false;

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const tileType = ref('image');
const tileTitle = ref('');
const tileSize = ref('auto');
const tileMod = ref(null);
const selectModActive = ref(false);

const imagePreviewUrl = computed(() => {
  if (!_.isNil(props.tile.image) && !_.isNil(props.tile.image.url)) {
    return props.tile.image.url;
  } else {
    return '';
  }
  return builder.currentItem.productLayout.title;
})

onMounted(() => {
  if (!_.isNil(props.tile.type)) {
    tileType.value = props.tile.type;
  }
  if (!_.isNil(props.tile.title)) {
    tileTitle.value = props.tile.title;
  }
});

function remove() {
  emit('tileRemove', props.index);
}

function updateProp(prop, val) {
  emit('tileUpdateProp', props.index, prop, val);
}

function activateSelectMod() {
  selectModActive.value = true;
}

function selectMod(id, mod) {
  updateProp('mod', {
    id: mod.id,
    title: mod.title,
    url: mod.image
  });
  selectModActive.value = false;
}

function handleFileSelected(file) {
  selectedFile = file;
  uploadFile();
}

// async function uploadFile() {
//   if (this.selectedFile) {
//     const formData = new FormData();
//     formData.append('file', this.selectedFile);

//     await fetch('/upload-endpoint', {
//       method: 'POST',
//       body: formData
//     });
//   }
// }

async function uploadFile() {

  axios.defaults.headers.common['Authorization'] = `Bearer ${builder.token}`;

  if (!builder.isSubmitted) {

    builder.isSubmitted = true;

    var action = '?action=my-diy-module/image/upload-via-builder';
    var method = 'post';

    try {

      const submitData = new FormData();
      submitData.append(window.csrfTokenName, window.csrfTokenValue);
      submitData.append('quoteId', builder.quote.id);
      submitData.append('itemId', builder.currentItem.id);
      submitData.append('testMode', builder.testMode);
      submitData.append('file', selectedFile);

      let responseObject = await axios({
        url: action ? action : window.location.href,
        method: method ? method : 'post',
        data: submitData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      builder.isSubmitted = false;
      builder.isSaved = true;

      let response = responseObject.data;
      if (response.success) {

        updateProp('image', response.image);

        console.log('Form posted successfully');
        console.log(response.success);
        console.log(response);

        return response;

      } else if (response.errors) {

        console.log('Form failed to submit');
        console.log('Field Errors', response.errors);
        console.log('Form Errors', response.formErrors);

        return false;

      } else {

        return false;

      }

    }
    catch (error) {

      builder.isSubmitted = false;

      console.error('Error!');
      console.error(error);

      return false;

    }

  } else {
    return false;
  }

}

</script>
